module.exports = __webpack_public_path__ + "assets/media/externalLinks-login-map.f46aa35e.svg";